module.exports = __webpack_public_path__ + "static/media/tick.14af72aa.svg";